/** A labelled value of the receipt */
export type ReceiptRow = {
  /** Name of the value */
  label: string;

  /** The value */
  value: string;
};

/**
 * @param text A text to show in the receipt
 * @returns the text with the HTML special characters escaped
 */
function escapeHtml(text: string): string {
  const element = document.createElement("div");
  element.textContent = text;
  return element.innerHTML;
}

/**
 * Prints the receipt of an IPX order, alone on the page instead of the whole viewer.
 * IPX is the seller, so the printout says it is paid to IPX and the invoice comes from IPX.
 *
 * @param rows The values of the receipt
 */
export function printIpxReceipt(rows: ReceiptRow[]): void {
  const frame = document.createElement("iframe");
  frame.setAttribute("aria-hidden", "true");
  Object.assign(frame.style, {
    position: "fixed",
    width: "0",
    height: "0",
    border: "0",
  });
  document.body.appendChild(frame);

  const doc = frame.contentDocument;
  const view = frame.contentWindow;
  if (!doc || !view) {
    frame.remove();
    return;
  }

  doc.open();
  doc.write(`<!doctype html>
<html>
  <head>
    <meta charset="utf-8" />
    <title>Receipt - Integrated Projects (IPX) order</title>
    <style>
      body { font-family: system-ui, sans-serif; color: #1f2937; margin: 40px; }
      h1 { font-size: 20px; margin: 0 0 4px; }
      p { margin: 0 0 24px; color: #4b5563; font-size: 13px; }
      table { border-collapse: collapse; width: 100%; max-width: 560px; }
      td { padding: 8px 0; border-bottom: 1px solid #e5e7eb; font-size: 14px; }
      td:last-child { text-align: right; font-weight: 600; }
    </style>
  </head>
  <body>
    <h1>Receipt - Integrated Projects (IPX) order</h1>
    <p>Paid to Integrated Projects (IPX). The invoice is issued by IPX. Printed from Sphere XG on ${escapeHtml(new Date().toLocaleString())}.</p>
    <table>
      ${rows.map(({ label, value }) => `<tr><td>${escapeHtml(label)}</td><td>${escapeHtml(value)}</td></tr>`).join("")}
    </table>
  </body>
</html>`);
  doc.close();

  view.addEventListener("afterprint", () => frame.remove());
  view.focus();
  view.print();
}
